export const MAX_CAMPAIGN_NAME_LENGTH = 94;
